// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__mufWJ","footerImage":"Footer_footerImage__Te1HT"};